import React, { useState, useEffect } from "react"
import "./validate-points.scss"
import { contenidoRedencion } from "./jsonContent.js"
import { BLOCKS, MARKS } from "@contentful/rich-text-types"
import { documentToReactComponents } from "@contentful/rich-text-react-renderer"
import { randomBytes } from "crypto"
import Button from "../../../shared/components/atoms/button/button"
import MyPointsService from "../../../shared/services/my-points-service"

const ValidatePoints = props => {
  const { costRedeem } = props
  const [myKey, setMyKey] = useState("")
  const [availablePoints, setAvailablePoints] = useState()
  const [servMessage, setServMessage] = useState("")
  const [servOk, setServOk] = useState(true)
  const [tokenID, setTokenID] = useState()

  function randomKey() {
    return randomBytes(10).toString()
  }

  const handleAquirePoints = e => {
    e.preventDefault()
    setServMessage("")
    setServOk(true)

    if (tokenID && myKey) {
      let config = {
        headers: {
          Authorization: tokenID,
        },
      }

      let payload = {
        activity: "Muestreo Sexologa",
        key: {
          code: myKey.toUpperCase().replace(/\s/g, ""),
        },
      }

      MyPointsService.postMyKeys(payload, config).then(res => {
        if (res.status === 200) {
         let totalPoints = availablePoints ? +res.data.points + +availablePoints: res.data.points;
         sessionStorage.setItem("Points", totalPoints)
         window.location.reload(); 
        } else {
          console.error(res)
          setServOk(false)
          setServMessage(res.userMessage)
        }
      })
    } else {
      setServMessage('Completa este campo')
    }
  }

  useEffect(() => {
    var tokenInfo = localStorage.getItem("TOKEN_INFO")
    var userInfo = localStorage.getItem("USER_INFO")
    const isUserAuth = !!tokenInfo && !!userInfo
    if (isUserAuth) {
      const { idToken } = JSON.parse(tokenInfo)
      const { userPoints } = JSON.parse(userInfo)
      setTokenID(idToken)
      let points = sessionStorage.getItem("Points");
      let isRedeemPoints = sessionStorage.getItem("isRedeemPoints");
      
      if(points){
        sessionStorage.removeItem("Points");
        setAvailablePoints(+points);
      } else  {
        if(isRedeemPoints){
          sessionStorage.removeItem("isRedeemPoints");
          setAvailablePoints(+userPoints.pointsAccumulation + +userPoints.pointsPresent-+costRedeem);
        }else {
          setAvailablePoints(
            +userPoints.pointsAccumulation + +userPoints.pointsPresent
          )
        }
      }
    }
  }, [])
  let canRedeem = availablePoints >= costRedeem
  return (
    <div className="container__form">
      <div className="details">
        <div className="detail-steps">
          <div className="container__title">
            <h1 key={randomKey()} className="text-color-primary">
               Tienes {availablePoints} PUNTOS
            </h1>
            <p class="text-color-primary">en Nosotrasonline para hacer tu consulta</p>
          </div>
          {documentToReactComponents(contenidoRedencion.json, {
            renderNode: {
              [BLOCKS.HEADING_1]: (node, children) => (
                <h1 key={randomKey()} className="text-color-primary">
                  {children}
                </h1>
              ),
              [BLOCKS.PARAGRAPH]: (node, children) => (
                <div className="container__text" key={JSON.stringify(node ? node : {})}>{children}</div>
              ),
            },
            renderMark: {
              [MARKS.UNDERLINE]: text => <u key={randomKey()}>{text}</u>,
            },
            renderText: text => {
              if (/\%REDEEM\%/g.test(text)) {
                return (
                  <Button
                    onClick={e => {
                      if (canRedeem) {
                        props.setStep(1)
                      }
                    }}
                    disabled={!canRedeem}
                    className={`button${
                      !canRedeem ? "-disabled" : ""
                    } background-color-primary`}
                    title="Redimir y consultar"
                  />
                )
              } else if (/\%SEND\%/g.test(text)) {
                return (
                  <form key="myKeyForm" 
                  id="myKey"
                  >
                    <input
                      id="myKeyInput"
                      key="myKeyInput"
                      type="text"
                      required
                      className="input-redention"
                      placeholder="- - - - - -"
                      value={myKey}
                      onChange={e => {
                        e.preventDefault()
                        e.persist()
                        setMyKey(s => e.target.value)
                      }}
                    />
                    {servMessage && (
                      <span className={`serv-message${servOk ? "" : "-error"}`}>
                        {servMessage}
                      </span>
                    )}
                    <Button
                      form="myKey"
                      onClick={handleAquirePoints}
                      className="button background-color-primary"
                      title="Enviar"
                    />
                  </form>
                )
              } else if (/\%POINTS\%/g.test(text)) {
                return text.replace("%POINTS%", availablePoints)
              } else if (/\%COST\%/g.test(text)) {
                return (
                  <p className="text-color-primary">
                    {text.replace("%COST%", costRedeem)}
                  </p>
                )
              } else {
                return <p className="text-color-primary">{text}&nbsp;</p>
              }
            },
          })}
        </div>
      </div>
    </div>
  )
}

export default ValidatePoints
